// extracted by mini-css-extract-plugin
export default {"tabs":"I1-z","tablist":"J1-z","tablistItem":"K1-z"};